module.exports = __webpack_public_path__ + "static/img/14.2b3b5c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/14.jpg
// module id = zcya
// module chunks = 0